module.exports = __webpack_public_path__ + "img/full_screen.9e108d7e.svg";